"use client";

import { useState, useRef, useEffect } from "react";
import { useAuth } from "@/contexts/auth-context";
import { useTheme } from "@/contexts/theme-context";
import { LogOut } from "lucide-react";
import { useRouter } from "next/navigation";
import { FontSizeSelector } from "@/components/ui/font-size-selector";
import { Switch } from "@/components/ui/switch";

export function UserMenu() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [isOpen]);

  const handleLogout = async () => {
    await logout();
    router.push("/login");
  };

  if (!user) return null;

  const initial = user.name.charAt(0).toUpperCase();

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="size-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-15 font-bold hover:brightness-95 transition-all"
        aria-label="Menu do usuário"
      >
        {initial}
      </button>

      {isOpen && (
        <div className="absolute right-0 top-full mt-2 min-w-[224px] rounded-xl border border-border bg-secondary shadow-[0_8px_32px_rgba(0,0,0,0.5)] z-50 p-3">
          <FontSizeSelector />
          <div className="mt-3 pt-3 border-t border-border">
            <Switch
              checked={theme === "light"}
              onChange={toggleTheme}
              label="Tema claro"
              className="bg-muted"
            />
          </div>
          <div className="mt-3 pt-3 border-t border-border">
            <button
              onClick={handleLogout}
              className="w-full flex items-center justify-center gap-2 h-9 rounded-lg text-xs font-bold text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
            >
              <LogOut className="size-3.5" />
              Sair
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
